
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M497 25H15C6.716 25 0 31.716 0 40v112c0 8.284 6.716 15 15 15h46v305c0 8.284 6.716 15 15 15h360c8.284 0 15-6.716 15-15V167h46c8.284 0 15-6.716 15-15V40c0-8.284-6.716-15-15-15zM191 457H91v-50h100v50zm0-210v50H91v-50h100zM91 217v-50h200v50H91zm200 110v50H91v-50h200zm130 130H221v-50h200v50zm0-80H321v-50h100v50zm0-80H221v-50h200v50zm0-80H321v-50h100v50zm61-80H30V55h452v82z"}})])
          )
        }
      }
    